import React, {useContext} from "react";
import {TimelineFrameQuestionnaireContext} from "./TimelineFrameContentQuestionnairesWrapper";
import QLink from "../../../../../timeline/components/QLink";
import {connect} from "react-redux";
import {QUESTIONNAIRES} from "../../../../../../data/reducer";
import {FormattedMessage} from "react-intl";

const { id: module_id } = module;

const TimelineFrameContentQuestionnaires = ({qIsFetching}) => {
    const questionnaires = useContext(TimelineFrameQuestionnaireContext);

    return (
        <>
            <FormattedMessage id={`${module_id}.appointment.related.questionnaires`} values={{
                strong: (chunks) => <strong>{chunks}</strong>
            }}/>
            <br />
            <FormattedMessage id={`${module_id}.questionnaire.reminder`} />
            <div className="span12" style={{marginTop: "5px"}}>
                <ul className="timeline-frame-questionnaire-list">
                    {
                        questionnaires.map(q => (
                            <QLink
                                key={q.id}
                                qIsFetching={qIsFetching}
                                questionnaire={q}
                            />
                        ))
                    }
                </ul>
            </div>
        </>

    )
}

const mapStateToProps = (state) => {
    let qIsFetching = state[QUESTIONNAIRES].isFetching;
    return {
        qIsFetching
    }
}
export default connect(mapStateToProps)(TimelineFrameContentQuestionnaires)